import { render } from "./AppPriceDetailsModal.vue?vue&type=template&id=34a1cafe&scoped=true"
import script from "./AppPriceDetailsModal.vue?vue&type=script&lang=js"
export * from "./AppPriceDetailsModal.vue?vue&type=script&lang=js"

import "./AppPriceDetailsModal.vue?vue&type=style&index=0&id=34a1cafe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a1cafe"]])

export default __exports__